// Function loadWoolLabOnboardingBlock loads the WoolLabOnboardingBlock class by dynamically importing the js on demand if needed

export function loadWoolLabOnboardingBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-fabric-swatch-favourites-block-chunk" */ '../widgets/woolLabOnboardingBlock').then(wg => {

		const { WoolLabOnboardingBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WoolLabOnboardingBlock"]');

		if(!$wg) {
			// console.info('WoolLabOnboardingBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WoolLabOnboardingBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WoolLabOnboardingBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WoolLabOnboardingBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the WoolLabOnboardingBlock widget');

}
